import React, { useState } from 'react'
import { useLanguage } from '../context/LanguageContext';
import api from '../lib/api';
import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const Terms = () => {
    const [termsData, setTermsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const { language, translate } = useLanguage();

    const isRTL = language === "ar";

    const fetchTermsData = async () => {
        try {
            setLoading(true);
            const lang = isRTL ? "ar" : "en";

            const response = await api.get(`/pagesettings/terms-conditions?lang=${lang}`);
            setTermsData(response.data.terms_conditions || []);
        } catch (error) {
            console.error("Error fetching terms and conditions:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTermsData();
    }, [language]);
    return (
        <div className='pb-10'>
            {
                loading ? (
                    <div className="flex flex-col items-center justify-center py-20">
                        <Loader2 className="animate-spin text-blue-500" size={48} />
                        <p className="mt-4 text-gray-400">
                            {translate("common.loading") || "Loading terms and conditions..."}
                        </p>
                    </div>
                ) :
                    (
                        <>
                            {/* Page Heading */}
                            <div className="w-full bg-primary border-b-2 border-gray px-6 py-4 min-h-[120px]">
                                <div className="max-w-[1600px] mx-auto">
                                    <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
                                        {translate("terms.title") || "Terms & Conditions"}
                                    </h1>
                                    <p className="text-description mb-4">
                                        {translate("terms.description")}

                                    </p>
                                </div>
                            </div>

                            {termsData && termsData.length > 0 ? (
                                (() => {
                                    const term = termsData[0];
                                    const allEmpty =
                                        (!term.title?.value || term.title.value.trim() === "") &&
                                        (!term.description?.value || term.description.value.trim() === "") &&
                                        (!term.imageUrl?.value || term.imageUrl.value.trim() === "");

                                    if (allEmpty) {
                                        return (
                                            <div className="flex flex-col items-center justify-center py-20">
                                                <p className="mt-4 text-gray-400">
                                                    {translate("terms.noTerms") || "No terms and conditions found."}
                                                </p>
                                            </div>
                                        );
                                    }

                                    return (
                                        <div className="px-6 mt-8">
                                            <div className="bg-card rounded overflow-hidden">
                                                {/* Image */}
                                                {term.imageUrl?.value && (
                                                    <img
                                                        src={term.imageUrl.value}
                                                        alt={term.title?.value || "Terms Image"}
                                                        className="w-full object-cover"
                                                    />
                                                )}

                                                <div className="p-8">
                                                    {/* Title */}
                                                    {term.title?.value && (
                                                        <h1 className="text-white text-3xl font-semibold mb-4">
                                                            {term.title.value}
                                                        </h1>
                                                    )}

                                                    {/* Description */}
                                                    {term.description?.value ? (
                                                        <div
                                                            className="max-w-none text-description  [&_ul]:list-disc [&_ul]:ml-6 [&_ol]:list-decimal [&_li]:mb-1 [&_h1]:text-2xl [&_h2]:text-2xl [&_h3]:text-xl [&_h4]:text-lg [&_h1]:text-white [&_h2]:text-white [&_h3]:text-white [&_h4]:text-white"
                                                            dangerouslySetInnerHTML={{
                                                                __html: term.description.value,
                                                            }}
                                                        />
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })()
                            ) : (
                                <div className="flex flex-col items-center justify-center py-20">
                                    <p className="mt-4 text-gray-400">
                                        {translate("terms.noTerms") || "No terms and conditions found."}
                                    </p>
                                </div>
                            )}
                        </>
                    )
            }
        </div>
    )
}

export default Terms